import { api } from './api';

export type StudentMyDocumentRow = {
  id: number;
  doc_type?: string | null;
  title?: string | null;
  original_name: string;
  mime_type?: string | null;
  size?: number | null;
  created_at?: string | null;
  uploaded_by_role?: string | null;
  uploaded_by_name?: string | null;
};

export async function listMyStudentDocuments(): Promise<StudentMyDocumentRow[]> {
  const resp = await api.get('/api/student/documents');
  return Array.isArray(resp.data) ? (resp.data as any) : [];
}

export async function uploadMyStudentDocuments(payload: {
  files: File[];
  doc_type?: string | null;
  title?: string | null;
}): Promise<{ ids: number[] }> {
  const form = new FormData();
  for (const f of payload.files || []) form.append('files', f);
  if (payload.doc_type) form.append('doc_type', payload.doc_type);
  if (payload.title) form.append('title', payload.title);
  const resp = await api.post('/api/student/documents', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return resp.data as any;
}

export function getMyStudentDocumentDownloadUrl(docId: number): string {
  return `/api/student/documents/${docId}/download`;
}

export async function listParentChildDocuments(childId: number): Promise<StudentMyDocumentRow[]> {
  const resp = await api.get(`/api/parinte/copii/${encodeURIComponent(String(childId))}/documents`);
  return Array.isArray(resp.data) ? (resp.data as any) : [];
}

export async function uploadParentChildDocuments(
  childId: number,
  payload: {
    files: File[];
    doc_type?: string | null;
    title?: string | null;
  }
): Promise<{ ids: number[] }> {
  const form = new FormData();
  for (const f of payload.files || []) form.append('files', f);
  if (payload.doc_type) form.append('doc_type', payload.doc_type);
  if (payload.title) form.append('title', payload.title);
  const resp = await api.post(`/api/parinte/copii/${encodeURIComponent(String(childId))}/documents`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return resp.data as any;
}

export function getParentChildDocumentDownloadUrl(childId: number, docId: number): string {
  return `/api/parinte/copii/${encodeURIComponent(String(childId))}/documents/${encodeURIComponent(String(docId))}/download`;
}
